import {CrudModel} from '@ngx-ivengi/crud';
import {FileService} from '../file/file.service';

export class Picture extends CrudModel {
  public type: string;
  public createdDate: Date;
  public file: FileList;

  public fileId: string;
  public fileName: string;
  public fileSrc: string = '';

  public setType(type: any): Picture {
    this.type = type;
    return this;
  }

  public setCreatedDate(createdDate: any): Picture {
    if(!isNaN(Date.parse(createdDate))) {
      this.createdDate = new Date(createdDate);
    }
    return this;
  }

  public setFile(files: FileList): Picture {
    if(files instanceof FileList) {
      this.file = files;
    }
    return this;
  }

  public setFileId(fileId: string): Picture {
    if(typeof fileId === 'string') {
      this.fileId = fileId;
    }
    return this;
  }

  public setFileName(fileName: string): Picture {
    if(typeof fileName === 'string') {
      this.fileName = fileName;
    }
    return this;
  }

  public setFileSrc(fileSrc: string): Picture {
    if(typeof fileSrc === 'string') {
      this.fileSrc = fileSrc;
    }
    return this;
  }



  fromResponse(response: any): void {
    this
      .setId(response.id)
      .setType(response.type)
      .setCreatedDate(response.createdDate);

    if(response.file) {
      this
        .setFileId(response.file.id)
        .setFileName(response.file.name);
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/picture/picture.model.ts